import * as React from "react";
import { Field } from "formik";
import styled from "styled-components";
import Switch from "components/common/Switch";
import BigLabel from "report/report-creation/BigLabel";
const OptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 5px;
`;
const FormikSwitch = ({ name, label, disabled = false }) => /* @__PURE__ */ React.createElement(OptionContainer, null, /* @__PURE__ */ React.createElement(Field, { name, type: "checkbox" }, ({ field: { value }, form: { setFieldValue }, meta: { error } }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(BigLabel, { htmlFor: name }, label), /* @__PURE__ */ React.createElement(
  Switch,
  {
    name,
    onChange: (e) => setFieldValue(name, e.target.checked),
    checked: value,
    disabled,
    id: name
  }
), error ? /* @__PURE__ */ React.createElement("span", null, error) : null)));
export default FormikSwitch;
